import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.9054 5.10156L8.26544 11.7156L5.32244 8.73456L3.89844 10.1396L8.25144 14.5486L16.3144 6.51956L14.9054 5.10156Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgCheckSmall);
export { ForwardRef as ReactComponent };
